import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const CLEAR_USER = 'CLEAR_USER'
export const SET_SELECTED_STATION = 'SET_SELECTED_STATION'
export const TOGGLE_DARK_THEME = 'TOGGLE_DARK_THEME'
export const SET_AUTO_LOGOUT_TIME = 'SET_AUTO_LOGOUT_TIME'
export const TOGGLE_AUTO_LOGOUT = 'TOGGLE_AUTO_LOGOUT'
export const REFRESH_STATIONS = 'REFRESH_STATIONS'
export const SET_METER_READING_DATE = 'SET_METER_READING_DATE'
export const SET_WALLET_ENABLED = 'SET_WALLET_ENABLED'

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    appName: process.env.VUE_APP_NAME,
    logo: process.env.VUE_APP_LOGO,
    isUserAuthenticated: false,
    userInfo: {
      name: '',
      email: '',
      permissions: '',
      roles: [],
      authenticationToken: '',
    },
    autoLogoutTime: 15,
    meterReadingDate: 25,
    isAutoLogoutEnabled: true,
    selectedStation: null,
    isDarkThemeEnabled: false,
    refreshStations: true,

    // Mirrors WALLET_ENABLED on the backend. The wallet stays hidden until the
    // login or settings response reports it as on.
    isWalletEnabled: false,
  },
  getters: {
    isUserAuthenticated: state => state.isUserAuthenticated,
    userInfo: state => state.userInfo,
    userPermissions: state => state.userInfo.permissions,
    userRoles: state => state.userInfo.roles, // ✅ new getter
    selectedStation: state => state.selectedStation,
    isDarkThemeEnabled: state => state.isDarkThemeEnabled,
    autoLogoutTime: state => state.autoLogoutTime,
    isAutoLogoutEnabled: state => state.isAutoLogoutEnabled,
    shouldRefreshStations: state => state.refreshStations,
    meterReadingDate: state => state.meterReadingDate,
    appName: state => state.appName,
    logo: state => state.logo,
    isWalletEnabled: state => state.isWalletEnabled,
  },
  mutations: {
    [AUTHENTICATE_USER](state, payload) {
      state.isUserAuthenticated = true
      state.userInfo = payload
    },
    [CLEAR_USER](state) {
      state.isUserAuthenticated = false
      state.userInfo = {
        name: '',
        email: '',
        permissions: '',
        roles: [],
        authenticationToken: '',
      }
    },
    [SET_SELECTED_STATION](state, payload) {
      state.selectedStation = payload
    },
    [SET_AUTO_LOGOUT_TIME](state, payload) {
      state.autoLogoutTime = payload
    },
    [TOGGLE_DARK_THEME](state) {
      state.isDarkThemeEnabled = !state.isDarkThemeEnabled
    },
    [TOGGLE_AUTO_LOGOUT](state) {
      state.isAutoLogoutEnabled = !state.isAutoLogoutEnabled
    },
    [REFRESH_STATIONS](state, payload) {
      state.refreshStations = payload
    },
    [SET_METER_READING_DATE](state, payload) {
      state.meterReadingDate = payload
    },
    [SET_WALLET_ENABLED](state, payload) {
      state.isWalletEnabled = payload
    },
  },
  actions: {
    authenticateUser({ commit }, payload) {
      commit(AUTHENTICATE_USER, payload)
    },
    clearUser({ commit }) {
      commit(CLEAR_USER)
    },
    setSelectedStation({ commit }, payload) {
      commit(SET_SELECTED_STATION, payload)
    },
    setAutoLogoutTime({ commit }, payload) {
      commit(SET_AUTO_LOGOUT_TIME, payload)
    },
    toggleAutoLogout({ commit }) {
      commit(TOGGLE_AUTO_LOGOUT)
    },
    toggleDarkTheme({ commit }) {
      commit(TOGGLE_DARK_THEME)
    },
    refreshStations({ commit }, payload) {
      commit(REFRESH_STATIONS, payload)
    },
    setMeterReadingDate({ commit }, payload) {
      commit(SET_METER_READING_DATE, payload)
    },
    setWalletEnabled({ commit }, payload) {
      commit(SET_WALLET_ENABLED, payload)
    },
  },
  modules: {},
})
